import { HasId } from "app/shared/model/properties.model";
import { Utils } from "ng/src/app/core/utils";

export class LogbookUtils {
	static collectionUpdate<T extends HasId, K extends string>(newSrc: T[], oldSrc: T[], key: K): CollectionUpdate<K, T> {
		const update = {
			addToCollections: {
				[key]: [] as T[]
			},
			removeFromCollections: {
				[key]: [] as T[]
			}
		} as CollectionUpdate<K, T>;
		
		const newMap = Utils.arrayToMap(newSrc, 'id');
		const oldMap = Utils.arrayToMap(oldSrc, 'id');
		
		newSrc.forEach(entry => {
			if (!(entry.id in oldMap)) {
				update.addToCollections[key].push(entry);
			}
		});
		
		oldSrc.forEach(entry => {
			if (!(entry.id in newMap)) {
				update.removeFromCollections[key].push(entry);
			}
		});
		
		return update;
	}
	
	static mapCollectionUpdateToIds<T extends CollectionUpdate<PropertyKey, HasId>>(input: T): CollectionUpdateUrlMap<T> {
		
		const addToCollections = Object.entries(input.addToCollections).reduce((map, entry) => {
			map[entry[0] as keyof CollectionUpdateUrlMap<T>['addToCollections']] = entry[1].map(e => e.id);
			return map;
		}, {} as CollectionUpdateUrlMap<T>['addToCollections']);
		
		const removeFromCollections = Object.entries(input.removeFromCollections).reduce((map, entry) => {
			map[entry[0] as keyof CollectionUpdateUrlMap<T>['removeFromCollections']] = entry[1].map(e => e.id);
			return map;
		}, {} as CollectionUpdateUrlMap<T>['removeFromCollections']);
		
		
		return {
			addToCollections,
			removeFromCollections
		} as CollectionUpdateUrlMap<T>;
	}
}

type CollectionUpdate<K extends PropertyKey, T> = {
	addToCollections: {
		[U in K]: T[]
	},
	removeFromCollections: {
		[U in K]: T[]
	}
}

type CollectionUpdateUrlMap<T extends CollectionUpdate<PropertyKey, any>> = {
	[K in keyof T]: {
		[U in keyof T[K]]: number[]
	}
}